import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import ReactGA from 'react-ga';
import { clarity } from 'react-microsoft-clarity';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN || '');
ReactGA.pageview(window.location.pathname + window.location.search);

clarity.init(process.env.REACT_APP_MS_CLARITY_TOKEN || '');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
